import { render } from "./SalesReport.vue?vue&type=template&id=06c900d9&scoped=true"
import script from "./SalesReport.vue?vue&type=script&lang=js"
export * from "./SalesReport.vue?vue&type=script&lang=js"

import "./SalesReport.vue?vue&type=style&index=0&id=06c900d9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c900d9"]])

export default __exports__